<template>
  <page-layout id="add-class-page" title="Add new class">
    <main-information
      @on-submit="addNewClass"
      ref="formRef"
      :serverValidations="serverValidations"
    >
      <template #footer-actions>
        <div class="form-actions text-center">
          <md-button class="md-raised" @click="clearForm">{{
            $t("common.cancel")
          }}</md-button>
          <md-button type="submit" class="md-success ml-4">{{
            $t("common.add")
          }}</md-button>
        </div>
      </template>
    </main-information>
  </page-layout>
</template>

<script>
import { MainInformation } from "./Forms";
import PageLayout from "@/pages/PageLayout.vue";
import { service_paths, cms_service_paths } from "@/constants/Services";
import { class_router_names } from "@/routes/routes";
import { Message, genErrMsgOj } from "@/helpers/utils";
import {SYSTEM } from "@/constants/System";

export default {
  components: { MainInformation, PageLayout },
  data() {
    return {
      serverValidations: {}
    };
  },
  methods: {
    addNewClass(formData) {
      const errMsg = this.$t("common.form_invalid");
      this.$axios
        .post(`${service_paths.classes}`, formData, {}, {}, errMsg)
        .then(async ({ data }) => {
          Message.success(this.$t("class.created_class_successfully"));
          setTimeout(
            () =>
              this.$router.push({
                name: class_router_names.detailPage,
                params: {
                  id: data.id
                }
              }),
            500
          );

          if (data.lms_id == 4) {
            let terms = (this.$refs.formRef || {}).termOpts || []
            let subjectName = (this.$refs.formRef || {}).subject.value.name

            let objParam = {
              ...data,
              sis_subject: subjectName,
              sis_term: (terms.find(x => x.id == data.term_id) || {}).name,
              id_ref: data.id,
              description: formData.description,
              program_learning_id: data.zone,
              source: SYSTEM.LMS
            }
            this.$axios.cms_post(`${cms_service_paths.class_add}`, [objParam], {}, {}, null, false)
          }
        })
        .catch(error => {
          const errorMessage = error.response?.data.messages;
          if (errorMessage) {
            this.serverValidations = genErrMsgOj(errorMessage);
          }
        });
    },

    clearForm() {
      this.$refs.formRef.clearForm();
      this.$router.push({
        name: class_router_names.listPage
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
